import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import { defineResources } from "./defineResources.ts";

export const ProfileMenuResources = defineResources({
  [LanguageEnum.CS]: {
    profileAriaLabel: "Profil",
    closeAriaLabel: "Zavřít",
    logoutButton: "Odhlásit se",
    manageAccount: "Spravovat účet Pičo",
    position: "Závodník Beer Rally",
    operationsTitle: "Operace",
    operationPending: "Zpracovává se…",
    operationCompleted: "Uloženo",
    operationFailed: "Selhalo",
    operationFailedToast: "Operaci se nepodařilo uložit",
  },
  [LanguageEnum.EN]: {
    profileAriaLabel: "Profile",
    closeAriaLabel: "Close",
    logoutButton: "Log out",
    manageAccount: "Manage Pičo account",
    position: "Beer Rally Driver",
    operationsTitle: "Operations",
    operationPending: "Processing…",
    operationCompleted: "Saved",
    operationFailed: "Failed",
    operationFailedToast: "Operation could not be saved",
  },
});
